import React from 'react';

type Spinner = {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  color?: 'primary' | 'success' | 'warning' | 'error' | 'info' | 'white';
  className?: string;
};

const Spinner = (props: Spinner) => {
  const { size = 'xl', color = 'primary', className = '' } = props;

  const sizeClasses = {
    sm: 'w-6 h-6 border-4',
    md: 'w-8 h-8 border-6',
    lg: 'w-10 h-10 border-6',
    xl: 'w-12 h-12 border-8',
    xxl: 'w-14 h-14 border-10',
  };

  const colorClasses = {
    primary: 'border-primary-500 border-t-[#FFFFFF]',
    success: 'border-green-500 border-t-[#FFFFFF]',
    warning: 'border-yellow-500 border-t-[#FFFFFF]',
    error: 'border-red-500 border-t-[#FFFFFF]',
    info: 'border-blue-500 border-t-[#FFFFFF]',
    white: 'border-white border-t-primary-500',
  };

  const baseClassName = `spinner animate-spin rounded-full ${size}`;

  const computedClassName = `${baseClassName} ${sizeClasses[size]} ${colorClasses[color]} ${className}`;

  return <div className={computedClassName}></div>;
};

export default Spinner;
